import type { CityData } from "@/components/CityPage";
import { IMAGES, BBN_REFERENCE_SOLFILM } from "@/lib/images";

export const CITIES: Record<string, CityData> = {
  malmo: {
    slug: "malmo",
    city: "Malmö",
    region: "Skåne",
    intro:
      "BBN Nordic är auktoriserad 3M-installatör med bas i Staffanstorp. 15 minuter från Malmö centrum. Vi monterar solfilm dagligen i kontor i Hyllie och Västra Hamnen, butiker i City och villor i Limhamn och Bunkeflostrand. Du får mätning på plats, en offert med fast pris och 10 års produktgaranti från 3M.",
    reach: "Hela Malmö stad inkl. Limhamn, Hyllie, Västra Hamnen, Rosengård och Bunkeflostrand",
    population: "350 000+",
    drive: "15 min",
    areas: [
      "Hyllie", "Västra Hamnen", "Limhamn", "City", "Möllevången", "Bunkeflostrand",
      "Oxie", "Husie", "Rosengård", "Lindängen", "Slottsstaden", "Kirseberg",
    ],
    image: BBN_REFERENCE_SOLFILM[0],
    localProof: [
      "Egen verkstad och lager 15 min från Malmö C. Vi kan komma samma vecka som offerten signeras",
      "Bred BRF-erfarenhet i Limhamn, Slottsstaden och Bunkeflostrand. Vi pratar med styrelsen, levererar protokoll och garantiintyg för stämman",
      "Glasfasadsprojekt i Hyllie och Västra Hamnen. Termisk stresstest före montage på belagda 3-glas och solskyddsglas",
      "Vi monterar utanför kontorstid utan extrakostnad inom Malmö stad",
    ],
    faqs: [
      { q: "Kör ni i hela Malmö?", a: "Ja, dagligen. Vi har egen verkstad i Staffanstorp och 15 minuters inkörning till alla Malmö-stadsdelar. Hyllie, Limhamn, Västra Hamnen, Bunkeflostrand, Oxie och övriga. Ingen reseersättning inom stadsgränsen." },
      { q: "Hur snabbt kan ni komma ut och mäta?", a: "Vanligtvis inom några dagar. Du får ett fast pris skriftligt efter mätningen, och offerten gäller i 30 dagar." },
      { q: "Kan ni montera åt bostadsrättsföreningar i Malmö?", a: "Ja. Vi tar dialogen med styrelse och fastighetsskötare, levererar protokoll och garanti­intyg som krävs för stämman." },
      { q: "Vad kostar solfilm för en villa i Malmö?", a: "Indikativt från 850 kr/m² inkl. moms och montage för 3M Prestige. Exakt pris efter mätning eftersom det beror på fönsterstorlek, höjd och åtkomst. Offert är alltid kostnadsfri." },
      { q: "Påverkar solfilm garantin på mina fönster?", a: "Nej. 3M-film är kvalitetstestad mot vanliga isolerglas och vi gör termisk stresstest före montering på 3-glas eller belagda rutor. Du får full 3M-produktgaranti i 10 år." },
    ],
  },
  helsingborg: {
    slug: "helsingborg",
    city: "Helsingborg",
    region: "Skåne",
    intro:
      "Vi är auktoriserade 3M-installatörer och monterar solfilm i Helsingborg. Vi hjälper kontor, butiker och villor i hela kommunen. från Drottninghög och Tågaborg till Råå och Mariastaden. Du får fast pris efter besiktning på plats, och 10 års 3M-garanti. Vi är på plats inom en vecka.",
    reach: "Helsingborg & nordvästra Skåne (Höganäs, Ängelholm, Bjuv, Åstorp)",
    population: "115 200+",
    drive: "45 min",
    areas: [
      "Centrum", "Drottninghög", "Råå", "Maria", "Pålsjö", "Ramlösa",
      "Mariastaden", "Husensjö", "Tågaborg", "Eneborg", "Wilson Park",
    ],
    image: BBN_REFERENCE_SOLFILM[1],
    localProof: [
      "Återkommande uppdrag i nordvästra Skåne. Helsingborg, Höganäs, Ängelholm, Bjuv och Åstorp",
      "Bred erfarenhet av kulturmärkta hus och blyspröjsade fönster. Vi väljer filmtyp och termisk stresstest så ingen ruta spricker",
      "3M Prestige rekommenderas för havsutsikt mot Öresund. klar film utan spegeleffekt utåt",
      "Garantin gäller fullt ut även i kustnära miljö (salt, fukt, UV)",
    ],
    faqs: [
      { q: "Hur långt norrut kör ni?", a: "Vi tar hela nordvästra Skåne. Helsingborg, Höganäs, Ängelholm, Bjuv och Åstorp. Ingen reseersättning inom området." },
      { q: "Klarar ni gamla blyspröjsade fönster och kulturmärkta hus?", a: "Ja. Vi väljer filmtyp utifrån glaskonstruktion och utför termisk stresstest för att undvika sprickor. För kulturmärkta fastigheter rekommenderar vi 3M Prestige som är klar och bevarar fasadens utseende." },
      { q: "Hur lång garanti gäller i Helsingborg?", a: "10 års full 3M-produktgaranti för invändig film, 7 år för utvändig. Garantin gäller mot färgförändring, sprickbildning och delaminering. Den täcker också eventuell rutskada som filmen har orsakat." },
      { q: "Vilken solfilm passar bäst för havsutsikt?", a: "3M Prestige 70. Filmen är helt klar utan spegeleffekt utåt och bevarar utsikten mot Öresund. Du blockerar värmen men ser ut precis som tidigare." },
    ],
  },
  lund: {
    slug: "lund",
    city: "Lund",
    region: "Skåne",
    intro:
      "Vi monterar solfilm i Lund och hjälper Lunds universitet, life science-klustret i Medicon Village, kontorsbygden i Brunnshög och villaområdena i Norra Fäladen och Klostergården. Som auktoriserade 3M-installatörer levererar vi fullständiga datablad, miljödeklarationer och garantiintyg för fastighetsförvaltare, miljösamordnare och LEED/BREEAM-certifieringar. 10 minuter från vår verkstad i Staffanstorp.",
    reach: "Hela Lunds kommun + Lomma, Staffanstorp, Eslöv, Bjärred",
    population: "125 200+",
    drive: "10 min",
    areas: [
      "Centrum", "Möllevången", "Klostergården", "Norra Fäladen", "Linero",
      "Brunnshög", "Värpinge", "Gunnesbo", "Tuna", "Stångby", "Veberöd",
    ],
    image: BBN_REFERENCE_SOLFILM[2],
    localProof: [
      "10 minuter från Lund. närmaste storstaden till vår verkstad",
      "Vana vid life science-miljöer (Medicon Village): rena montage utan damm, ID06-hantering, säkerhetsföreskrifter",
      "LEED/BREEAM-dokumentation levereras (EPD, datablad, garantiintyg)",
      "Vi planerar monteringen så att den stör ert kontor så lite som möjligt",
    ],
    faqs: [
      { q: "Klarar ni LEED- och BREEAM-projekt?", a: "Ja. Vi levererar fullständiga datablad, EPD-miljödeklarationer och garantiintyg som krävs för certifieringar. 3M-filmen bidrar till poäng inom Energy och Indoor Environmental Quality." },
      { q: "Får vi montera under arbetsdag?", a: "Ja, det går bra. Vi tar det rum för rum så att ni kan jobba som vanligt i resten av lokalen." },
      { q: "Hur är installationsprocessen för universitetet?", a: "Vi hanterar säkerhetsföreskrifter, ID06 och rena montage utan damm. kritiskt för labb och föreläsningssalar." },
      { q: "Hur lång hållbarhet har solfilm i Lund?", a: "3M Prestige håller minst 15–20 år vid invändig montering. Vi har film från 2008 som fortfarande presterar enligt datablad. Garantin är 10 år men livslängden är längre." },
    ],
  },
  goteborg: {
    slug: "goteborg",
    city: "Göteborg",
    region: "Västra Götaland",
    intro:
      "Vi monterar solfilm i Göteborg och har lokal montörsbas i Västsverige och kör projekt från Hisingen och Lindholmen till Hovås och Askim. Auktoriserad 3M-installatör av kontor med glasfasader, butiker i köpcentrum och villor med havsutsikt. Du får samma fasta priser som i Skåne och betalar ingen reseersättning. Våra certifierade montörer utför arbetet med samma 10 års 3M-garanti.",
    reach: "Storgöteborg + Mölndal, Kungsbacka, Partille, Lerum, Kungälv",
    population: "600 000+",
    drive: "Lokal montör",
    areas: [
      "Centrum", "Hisingen", "Majorna", "Hovås", "Askim", "Lindholmen",
      "Frölunda", "Mölndal", "Partille", "Lerum", "Kungälv", "Torslanda",
    ],
    image: BBN_REFERENCE_SOLFILM[3],
    localProof: [
      "Lokal montörsbas i Västsverige. Ingen reseersättning",
      "Glasfasadsprojekt på Lindholmen och Hisingen: 3M Prestige för klar sikt, Night Vision för diskret mörkare exteriör",
      "Solfilm testad för västkustklimat (UV, fukt, salt). full garanti i Hovås, Askim och Torslanda",
      "Mätning oftast inom en vecka, montage 2–3 veckor från godkänd offert",
    ],
    faqs: [
      { q: "Är ni baserade i Göteborg?", a: "Vi har lokal montörsbas i Västsverige och huvudkontor i Skåne. Ingen reseersättning, samma fasta priser som i Skåne." },
      { q: "Hur snabbt kan ni starta ett projekt?", a: "Mätning oftast inom en vecka, därefter en offert med fast pris, montage typiskt 2–3 veckor från godkänd offert. Akuta säkerhetsfilm-uppdrag kan prioriteras." },
      { q: "Vilken film passar för kontor på Lindholmen och Hisingen?", a: "För moderna glasfasader rekommenderar vi 3M Prestige (klar med högt ljusgenomsläpp, hög värmereduktion) eller 3M Night Vision om utsidan ska se diskret mörkare ut. Vi mäter sol­exponering och föreslår rätt produkt." },
      { q: "Klarar solfilm västkustklimatet?", a: "Ja. 3M-film är testad för UV, fukt och salthaltig luft. Garantin gäller fullt ut även i kustnära miljö som Hovås, Askim och Torslanda." },
    ],
  },
  stockholm: {
    slug: "stockholm",
    city: "Stockholm",
    region: "Stockholms län",
    intro:
      "Vi monterar solfilm i Stockholm och har lokal montörsbas i Mälardalen och kör projekt från Kista och Solna till Södermalm, Bromma och Nacka. Auktoriserad 3M-installatör av kontor med glasfasader i City och Hammarby Sjöstad, butiker i Mall of Scandinavia och Westfield Mall of Scandinavia, samt villor i Djursholm, Lidingö och Saltsjöbaden. Du får samma fasta priser som i Skåne och betalar ingen reseersättning. Våra certifierade montörer utför arbetet med samma 10 års 3M-garanti. Referensprojekt: Vasakronan Kista Science Tower och Kista Entré.",
    reach: "Storstockholm + Solna, Sundbyberg, Nacka, Lidingö, Täby, Sollentuna",
    population: "1 000 000+",
    drive: "Lokal montör",
    areas: [
      "City", "Södermalm", "Östermalm", "Vasastan", "Kungsholmen", "Hammarby Sjöstad",
      "Kista", "Solna", "Sundbyberg", "Bromma", "Nacka", "Lidingö",
      "Djursholm", "Täby", "Sollentuna", "Saltsjöbaden",
    ],
    image: BBN_REFERENCE_SOLFILM[4],
    localProof: [
      "Lokal montörsbas i Mälardalen. Ingen reseersättning inom Storstockholm",
      "Referensprojekt: Vasakronan Kista Science Tower & Kista Entré (3M Prestige 40x på glasfasad)",
      "Vana vid kommersiella fastigheter i City, Hammarby Sjöstad och Kista. ID06, säkerhetsföreskrifter och rena montage utan damm",
      "Vi planerar monteringen med er så att banker, advokatbyråer och tech-kontor kan jobba som vanligt",
    ],
    faqs: [
      { q: "Är ni baserade i Stockholm?", a: "Vi har lokal montörsbas i Mälardalen och huvudkontor i Skåne. Ingen reseersättning, samma fasta priser som i Skåne. Vi kör projekt dagligen i Storstockholm, Solna, Sundbyberg, Nacka, Lidingö, Täby och Sollentuna." },
      { q: "Vilka referensprojekt har ni i Stockholm?", a: "Vasakronan Kista Science Tower och Kista Entré är två av våra större kontorsprojekt. 3M Prestige 40x på moderna glasfasader. Vi har även monterat i villor på Lidingö och Djursholm samt i butiker i Mall of Scandinavia." },
      { q: "Hur snabbt kan ni starta ett projekt i Stockholm?", a: "Mätning oftast inom en vecka, därefter en offert med fast pris, montage typiskt 2–3 veckor från godkänd offert. Akuta säkerhetsfilm-uppdrag (krossade rutor, splitterskydd) prioriteras." },
      { q: "Vilken film passar för kontor i City och Hammarby Sjöstad?", a: "För moderna glasfasader rekommenderar vi 3M Prestige (klar med högt ljusgenomsläpp, hög värmereduktion) eller 3M Night Vision om utsidan ska se diskret mörkare ut. Vi mäter sol­exponering och föreslår rätt produkt. Termisk stresstest ingår före montage på 3-glas och belagda rutor." },
      { q: "Klarar ni LEED- och BREEAM-projekt i Stockholm?", a: "Ja. Vi levererar fullständiga datablad, EPD-miljödeklarationer och garantiintyg som krävs för certifieringar. 3M-filmen bidrar till poäng inom Energy och Indoor Environmental Quality. vanligt krav i nya kontorshus i Hagastaden och Hammarby Sjöstad." },
    ],
  },
};

const SITE = "https://bbnnordic.se";

/** Returnerar LocalBusiness + BreadcrumbList + FAQPage JSON-LD för en stadssida. */
export function buildCityLdJson(data: CityData) {
  const url = `${SITE}/solfilm-${data.slug}`;
  return [
    {
      "@context": "https://schema.org",
      "@type": "LocalBusiness",
      "@id": `${url}#business`,
      name: `BBN Nordic — Solfilm ${data.city}`,
      image: data.image ?? IMAGES.solfilmHero,
      description: data.intro,
      areaServed: { "@type": "City", name: data.city },
      // NAP — full huvudkontorsadress för Local Pack-trovärdighet
      address: {
        "@type": "PostalAddress",
        streetAddress: "Satellitvägen 16",
        postalCode: "245 34",
        addressLocality: "Staffanstorp",
        addressRegion: "Skåne",
        addressCountry: "SE",
      },
      telephone: "+46771502502",
      email: "info@bbnnordic.se",
      openingHours: "Mo-Fr 08:00-15:30",
      priceRange: "$$",
      url,
    },
    {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      itemListElement: [
        { "@type": "ListItem", position: 1, name: "Hem", item: `${SITE}/` },
        { "@type": "ListItem", position: 2, name: `Solfilm ${data.city}`, item: url },
      ],
    },
    {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: data.faqs.map((f) => ({
        "@type": "Question",
        name: f.q,
        acceptedAnswer: { "@type": "Answer", text: f.a },
      })),
    },
    // Speakable — markerar rubrik + intro så Google Assistant / ChatGPT Voice
    // läser rätt stycken vid röstsök på "solfilm <stad>".
    {
      "@context": "https://schema.org",
      "@type": "WebPage",
      "@id": url,
      url,
      name: `Solfilm ${data.city}`,
      speakable: {
        "@type": "SpeakableSpecification",
        cssSelector: ["h1", "[data-speakable='intro']"],
      },
    },
  ];
}

